import { autoserialize } from 'cerialize';

export class Organization {
  @autoserialize id!: string;
  @autoserialize name!: string;
  @autoserialize slug!: string;
}
